import React from 'react';
import './MenuSelector.css'

export class MenuSelector extends React.Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
        this.renderPickupTimes = this.renderPickupTimes.bind(this);
        this.handleTimeChange = this.handleTimeChange.bind(this);
    }
    componentDidMount() {
        this.props.setMealTime(this.props.mealTime);
    }
    handleChange(e) {
        this.props.setMealTime(e.target.value);
    }
    handleTimeChange(e) {
        this.props.setOrderTime(e.target.value);
    }
    renderPickupTimes() {
        if(this.props.mealTime === 'Lunch') {
            return (
                <select as="select" className = "pickup-times" onChange = {this.handleTimeChange}>
                        <option value = "11:30 AM">11:30 AM</option>
                        <option value = "12:00 PM">12:00 PM</option>
                        <option value = "12:30 PM">12:30 PM</option>
                        <option value = "1:00 PM">1:00 PM</option>
                </select>
            );
        }
        else {
            return  (
                 <select as="select" className = "pickup-times" onChange = {this.handleTimeChange}>
                            <option value = "5:00 PM">5:00 PM</option>
                            <option value = "5:30 PM">5:30 PM</option>
                            <option value = "6:00 PM">6:00 PM</option>
                            <option value = "6:30 PM">6:30 PM</option>
                            <option value = "7:00 PM">7:00 PM</option>
                            <option value = "7:30 PM">7:30 PM</option>
                 </select>
                );
        }
    }
    render() {
        return(
            <div className = {`${(this.props.mealTime === 'Lunch') ? 'lunch-bgr' : 'dinner-bgr'} menu-selector`}>
                <h2> Made fresh to order, everyday</h2>
                <div className = "menu-form">
                    {this.renderPickupTimes()}
                    <select as="select" onChange = {this.handleChange} 
                    className = 'meal-choice' value = {this.props.mealTime === 'Lunch' ? 'Lunch' : 'Dinner'}>
                            <option value = "Lunch">Lunch</option>
                            <option value = "Dinner">Dinner</option>
                    </select>
                </div>
            </div>
        );
    }

}